import { useRouteContext } from '@tanstack/react-router';
import { type RouteContextQuery, type RouteContextSelect, type RouteId } from '@/router/route-hooks.types';

const ROUTE_ID = '/_authenticated/_dashboard' satisfies RouteId;

export const useRouteContextQuery = <TSelected extends RouteContextQuery>(
  select: RouteContextSelect<typeof ROUTE_ID, TSelected>,
) => useRouteContext({ from: ROUTE_ID, select });
